import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-building.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-building.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AlertType } from "../../../../../../shared/models/alert";
import { CreateApplicationLocationBpConstants } from "../create-application-location-bp.constants";
import { AppConfig } from "../../../../../../app.config";
let EditBuildingComponent = class EditBuildingComponent {
    activeModal;
    appController;
    modalTitle;
    building;
    editedIndex;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    editForm;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    createLabel = SharedConstants.UPDATE_LABEL;
    validationMessages = CreateApplicationLocationBpConstants.VALIDATION_MESSAGES;
    floorLabel = CreateApplicationLocationBpConstants.FLOOR_LABEL;
    existingSizeLabel = CreateApplicationLocationBpConstants.EXISTING_SIZE_LABEL;
    addedSizeLabel = CreateApplicationLocationBpConstants.ADDED_SIZE_LABEL;
    buildingNameNumberLabel = CreateApplicationLocationBpConstants.BUILDING_NAME_NUMBER_LABEL;
    floorControlName = CreateApplicationLocationBpConstants.FLOOR_CONTROL_NAME;
    existingSizeControlName = CreateApplicationLocationBpConstants.EXISTING_SIZE_CONTROL_NAME;
    addedSizeControlName = CreateApplicationLocationBpConstants.ADDED_SIZE_CONTROL_NAME;
    buildingNameNumberControlName = CreateApplicationLocationBpConstants.BUILDING_NAME_NUMBER_CONTROL_NAME;
    constructor(activeModal, appController) {
        this.activeModal = activeModal;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.editForm = new FormGroup({
            floor: new FormControl(this.building?.floor ?? null, [Validators.required]),
            existingSize: new FormControl(this.building?.existingSize ?? null, [Validators.required]),
            addedSize: new FormControl(this.building?.addedSize ?? null, [Validators.required]),
            buildingNameNumber: new FormControl(this.building?.buildingNameNumber ?? null),
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnSaveClicked($event) {
        if (this.editForm.valid) {
            this.building.floor = this.editForm.get(this.floorControlName).value;
            this.building.existingSize = this.editForm.get(this.existingSizeControlName).value;
            this.building.addedSize = this.editForm.get(this.addedSizeControlName).value;
            this.building.buildingNameNumber = this.editForm.get(this.buildingNameNumberControlName).value;
            this.activeModal.close([this.editedIndex, this.building]);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnCancelClicked($event) {
        this.activeModal.close(null);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        building: [{ type: Input }],
        editedIndex: [{ type: Input }]
    };
};
EditBuildingComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-building",
        template: __NG_CLI_RESOURCE__0,
        host: { "edit-building": "create-application" },
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditBuildingComponent);
export { EditBuildingComponent };
